module.exports = __webpack_public_path__ + "img/24_31.eaf7ceae.png";